var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.name,{tag:"component",attrs:{"labelId":_vm.labelId,"type":_vm.type},on:{"changeHandle":_vm.changeHandle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }